// Plan.jsx
import React, { useState } from 'react';
import Button from '../atoms/Button'; // ボタンコンポーネントをインポート
import EstimateModal from './EstimateModal';

const Plan = () => {
  const [selectedPlan, setSelectedPlan] = useState('book'); // "book", "photo", "printing"
  const [bookTab, setBookTab] = useState('printing'); // "data" or "printing"
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div id="plan" className="bg-white p-6 border-t border-black max-w-4xl mx-auto mt-8 pt-16" style={{ fontFamily: 'Hatton, serif' }}>
      <h2 className="text-3xl font-bold text-center text-gray-800 mb-8 font-serif tracking-wide uppercase" style={{ fontFamily: 'Hatton, serif' }}>
        Plan
      </h2>

      {/* Main Plan Toggle Buttons */}
      <div className="flex justify-center space-x-4 mb-8">
        <Button
          label="PROFILE BOOK"
          isActive={selectedPlan === 'book'}
          onClick={() => setSelectedPlan('book')}
        />
        {/* <Button
          label="WEDDING PHOTO"
          isActive={selectedPlan === 'photo'}
          onClick={() => setSelectedPlan('photo')}
        /> */}
        <Button
          label="SEATING CHART"
          isActive={selectedPlan === 'seating'}
          onClick={() => setSelectedPlan('seating')}
        />
      </div>

      {/* Conditional Rendering for Wedding Book */}
      {selectedPlan === 'book' && (
        <div>
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-8 font-serif uppercase tracking-wide" style={{ fontFamily: 'Hatton, serif' }}>
            Profile Book Plans
          </h2>

          {/* Sub-tabs for Wedding Book */}
          <div className="flex justify-center space-x-4 mb-8"  style={{ fontFamily: 'zenmaru, serif' }}>
            <Button
              label="データ納品プラン"
              isActive={bookTab === 'data'}
              onClick={() => setBookTab('data')}
              className='!font-medium'
            />
            <Button
              label="印刷込みプラン"
              isActive={bookTab === 'printing'}
              onClick={() => setBookTab('printing')}
              className='!font-normal'
            />
          </div>

          {/* Conditional Rendering for Data Delivery Plan */}
          {bookTab === 'data' && (
            <div>
              {/* <div className='flex justify-center my-5 text-xs text-gray-600 mt-6 leading-loose' style={{ fontFamily: 'zenmaru, serif' }}>
                <p className='text-center '>
                  中綴じ冊子 A5サイズ (210×148mm)<br />
                  印刷も併せてご希望の場合はこちらのプランをお選びください<br />

                </p>
              </div> */}
              <div className="border border-gray-800 p-4 mb-8" style={{ fontFamily: 'zenmaru, serif' }}>
                <h3 className="text-xl font-bold text-center mb-4 bg-amber-100 p-2 border-b border-gray-800 tracking-wide" style={{ fontFamily: 'Hatton, serif' }}>
                  semi order
                </h3>
                {/* Table-like Layout */}
                <div className="overflow-x-auto">
                  {/* <table className="table-auto w-full border-collapse border border-gray-800"> */}
                  <table className="table-auto border-collapse border border-gray-800 w-full">
                    <thead className="bg-gray-100">
                      <tr>
                        <th className="border border-gray-800 px-4 py-2"></th>
                        <th className="border border-gray-800 px-4 py-2">4P</th>
                        <th className="border border-gray-800 px-4 py-2">8P</th>
                        <th className="border border-gray-800 px-4 py-2">12P</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="bg-gray-100 border border-gray-800 px-4 py-2 text-center">価格</td>
                        <td className="border border-gray-800 px-4 py-2 text-center">¥20,000</td>
                        <td className="border border-gray-800 px-4 py-2 text-center">¥26,000</td>
                        <td className="border border-gray-800 px-4 py-2 text-center">¥35,000</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className='flex justify-center'>
                  <p className="text-xs text-center text-gray-600 mt-6 leading-relaxed" style={{ fontFamily: 'zenmaru, serif' }}>
                    公式HP・Instagram投稿内のデザインからお好きなページをご自由に組み合わせていただけます<br />
                  </p>
                </div>
              </div>
      
              <div className="border border-gray-800 p-4 mb-8">
                <h3 className="text-xl font-bold text-center mb-4 bg-amber-100 p-2 border-b border-gray-800 tracking-wide" style={{ fontFamily: 'Hatton, serif' }}>
                  option
                </h3>
                <div className="mt-6 space-y-8">
                  {[
                    { label: '席次表作成', 
                      price: '+¥4,000',
                      description: '※4Pをご希望の方は席次表プランから' 
                    },
                    {
                      label: 'お急ぎ納品',
                      price: '+¥10,000',
                      description:
                        'ご注文が挙式日より60日を切ってしまっている場合、こちらをお選びください（納品希望日30日前まで）\n※納品希望日は挙式日の20日前までとなります',
                    },
                    {
                      label: 'オリジナルページ作成',
                      price: '1ページにつき+¥3,000',
                      description:
                        'セミオーダー料金 + ご希望のオリジナルページ数×¥3,000\nお客様のご要望に合わせてデザインを1からお作りいたします',
                    }
                  ].map((option, index) => (
                    <div key={index} className="border border-gray-300 p-4 shadow-sm" style={{ fontFamily: 'zenmaru, serif' }}>
                      <div className="flex justify-between items-center mb-2">
                        <h4 className="text-medium font-semibold text-gray-800">{option.label}</h4>
                        <span className="text-gray-700 font-sm">{option.price}</span>
                      </div>
                      {option.description && (
                        <p className="text-xs text-gray-600 leading-relaxed whitespace-pre-line">{option.description}</p>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Conditional Rendering for Printing Plan */}
          {bookTab === 'printing' && (
            <div>
              {/* <div className='flex justify-center my-5 text-xs text-gray-600 mt-6 leading-loose' style={{ fontFamily: 'zenmaru, serif' }}>
                <p className='text-center '>
                  中綴じ冊子 A5サイズ (210×148mm)<br />
                  印刷も併せてご希望の場合はこちらのプランをお選びください<br />

                </p>
              </div> */}
              <div className="border border-gray-800 p-4 mb-8" style={{ fontFamily: 'zenmaru, serif' }}>
                <h3 className="text-xl font-bold text-center mb-4 bg-amber-100 p-2 border-b border-gray-800 tracking-wide" style={{ fontFamily: 'Hatton, serif' }}>
                  semi order
                </h3>
                {/* Table-like Layout */}
                <div className="overflow-x-auto">
                  {/* <table className="table-auto w-full border-collapse border border-gray-800"> */}
                  <table className="table-auto border-collapse border border-gray-800 w-full">
                    <thead className="bg-gray-100">
                      <tr>
                        <th className="border border-gray-800 px-4 py-2">ページ数</th>
                        <th className="border border-gray-800 px-4 py-2">4P</th>
                        <th className="border border-gray-800 px-4 py-2">8P</th>
                        <th className="border border-gray-800 px-4 py-2">12P</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="border border-gray-800 px-4 py-2 text-center">10〜50部</td>
                        <td className="border border-gray-800 px-4 py-2 text-center">¥25,000</td>
                        <td className="border border-gray-800 px-4 py-2 text-center">¥32,000</td>
                        <td className="border border-gray-800 px-4 py-2 text-center">¥42,000</td>
                      </tr>
                      <tr>
                        <td className="border border-gray-800 px-4 py-2 text-center">60部</td>
                        <td className="border border-gray-800 px-4 py-2 text-center">¥25,000</td>
                        <td className="border border-gray-800 px-4 py-2 text-center">¥32,500</td>
                        <td className="border border-gray-800 px-4 py-2 text-center">¥42,500</td>
                      </tr>
                      <tr>
                        <td className="border border-gray-800 px-4 py-2 text-center">70部</td>
                        <td className="border border-gray-800 px-4 py-2 text-center">¥25,000</td>
                        <td className="border border-gray-800 px-4 py-2 text-center">¥33,000</td>
                        <td className="border border-gray-800 px-4 py-2 text-center">¥43,000</td>
                      </tr>
                      <tr>
                        <td className="border border-gray-800 px-4 py-2 text-center">80部</td>
                        <td className="border border-gray-800 px-4 py-2 text-center">¥25,000</td>
                        <td className="border border-gray-800 px-4 py-2 text-center">¥33,500</td>
                        <td className="border border-gray-800 px-4 py-2 text-center">¥43,500</td>
                      </tr>
                      <tr>
                        <td className="border border-gray-800 px-4 py-2 text-center">90部</td>
                        <td className="border border-gray-800 px-4 py-2 text-center">¥25,000</td>
                        <td className="border border-gray-800 px-4 py-2 text-center">¥34,000</td>
                        <td className="border border-gray-800 px-4 py-2 text-center">¥44,000</td>
                      </tr>
                      <tr>
                        <td className="border border-gray-800 px-4 py-2 text-center">100部</td>
                        <td className="border border-gray-800 px-4 py-2 text-center">¥25,000</td>
                        <td className="border border-gray-800 px-4 py-2 text-center">¥34,500</td>
                        <td className="border border-gray-800 px-4 py-2 text-center">¥44,500</td>
                      </tr>
                      <tr>
                        <td className="border border-gray-800 px-4 py-2 text-center">〜200部</td>
                        <td className="border border-gray-800 px-4 py-2 text-center">¥26,000</td>
                        <td className="border border-gray-800 px-4 py-2 text-center">¥35,500</td>
                        <td className="border border-gray-800 px-4 py-2 text-center">¥45,500</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className='flex justify-center'>
                  <p className="text-xs text-center text-gray-600 mt-6 leading-relaxed" style={{ fontFamily: 'zenmaru, serif' }}>
                    公式HP・Instagram投稿内のデザインからお好きなページをご自由に組み合わせていただけます<br />
                    中綴じ冊子 A5サイズ (210×148mm)<br />
                  </p>
                </div>
              </div>
      
              <div className="border border-gray-800 p-4 mb-8">
                <h3 className="text-xl font-bold text-center mb-4 bg-amber-100 p-2 border-b border-gray-800 tracking-wide" style={{ fontFamily: 'Hatton, serif' }}>
                  option
                </h3>
                <div className="mt-6 space-y-8">
                  {[
                    { label: '席次表作成', 
                      price: '+¥3,500',
                      description: '' 
                    },
                    {
                      label: 'お急ぎ納品',
                      price: '+¥10,000',
                      description:
                        'ご注文が挙式日より60日を切ってしまっている場合、こちらをお選びください（納品希望日30日前まで）\n※納品希望日は挙式日の20日前までとなります',
                    },
                    {
                      label: 'オリジナルページ作成',
                      price: '1ページにつき+¥3,000',
                      description:
                        'セミオーダー料金 + ご希望のオリジナルページ数×¥3,000\nお客様のご要望に合わせてデザインを1からお作りいたします',
                    },
                    {
                      label: '試し刷り',
                      price: '+¥4,000',
                      description:
                        '仕上がりが気になる方は本番刷りの前に少ない部数で試し刷りが可能です',
                    },
                    {
                      label: '上質紙に変更',
                      price: '+¥1,000',
                      description:
                        '通常のマットコート紙に比べて光沢はほぼないものになります',
                    },
                  ].map((option, index) => (
                    <div key={index} className="border border-gray-300 p-4 shadow-sm" style={{ fontFamily: 'zenmaru, serif' }}>
                      <div className="flex justify-between items-center mb-2">
                        <h4 className="text-medium font-semibold text-gray-800">{option.label}</h4>
                        <span className="text-gray-700 font-sm">{option.price}</span>
                      </div>
                      {option.description && (
                        <p className="text-xs text-gray-600 leading-relaxed whitespace-pre-line">{option.description}</p>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Conditional Rendering for Seating Chart */}
      {selectedPlan === 'seating' && (
        <div>
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-8 font-serif uppercase tracking-wide" style={{ fontFamily: 'Hatton, serif' }}>
            Seating Chart Plans
          </h2>

          {/* Sub-tabs for Wedding Book */}
          <div className="flex justify-center space-x-4 mb-8"  style={{ fontFamily: 'zenmaru, serif' }}>
            <Button
              label="データ納品プラン"
              isActive={bookTab === 'data'}
              onClick={() => setBookTab('data')}
              className='!font-medium'
            />
            <Button
              label="印刷込みプラン"
              isActive={bookTab === 'printing'}
              onClick={() => setBookTab('printing')}
              className='!font-normal'
            />
          </div>

          {/* Conditional Rendering for Data Delivery Plan */}
          {bookTab === 'data' && (
            <div>
              {/* <div className='flex justify-center my-5 text-xs text-gray-600 mt-6 leading-loose' style={{ fontFamily: 'zenmaru, serif' }}>
                <p className='text-center '>
                  中綴じ冊子 A5サイズ (210×148mm)<br />
                  印刷も併せてご希望の場合はこちらのプランをお選びください<br />

                </p>
              </div> */}
              <div className="border border-gray-800 p-4 mb-8" style={{ fontFamily: 'zenmaru, serif' }}>
                <h3 className="text-xl font-bold text-center mb-4 bg-amber-100 p-2 border-b border-gray-800 tracking-wide" style={{ fontFamily: 'Hatton, serif' }}>
                  semi order
                </h3>
                {/* Table-like Layout */}
                <div className="overflow-x-auto">
                  {/* <table className="table-auto w-full border-collapse border border-gray-800"> */}
                  <table className="table-auto border-collapse border border-gray-800 w-full">
                    <thead className="bg-gray-100">
                      <tr>
                        <th className="border border-gray-800 px-4 py-2"></th>
                        <th className="border border-gray-800 px-4 py-2">二つ折り席次表（4P）</th>
                        <th className="border border-gray-800 px-4 py-2">巻三つ折り席次表（6P）</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr> <td className="bg-gray-100 border border-gray-800 px-4 py-2 text-center">価格</td>
                        <td className="border border-gray-800 px-4 py-2 text-center">¥16,000</td>
                        <td className="border border-gray-800 px-4 py-2 text-center">¥19,000</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className='flex justify-center'>
                  <p className="text-xs text-center text-gray-600 mt-6 leading-relaxed" style={{ fontFamily: 'zenmaru, serif' }}>
                    公式HP・Instagram投稿内のデザインからお好きなページをご自由に組み合わせていただけます<br />
                  </p>
                </div>
              </div>
      
              <div className="border border-gray-800 p-4 mb-8">
                <h3 className="text-xl font-bold text-center mb-4 bg-amber-100 p-2 border-b border-gray-800 tracking-wide" style={{ fontFamily: 'Hatton, serif' }}>
                  option
                </h3>
                <div className="mt-6 space-y-8">
                  {[
                    {
                      label: 'お急ぎ納品',
                      price: '+¥10,000',
                      description:
                        'ご注文が挙式日より60日を切ってしまっている場合、こちらをお選びください（納品希望日30日前まで）\n※納品希望日は挙式日の20日前までとなります',
                    },
                    {
                      label: 'オリジナルページ作成',
                      price: '1ページにつき+¥3,000',
                      description:
                        'セミオーダー料金 + ご希望のオリジナルページ数×¥3,000\nお客様のご要望に合わせてデザインを1からお作りいたします',
                    },
                  ].map((option, index) => (
                    <div key={index} className="border border-gray-300 p-4 shadow-sm" style={{ fontFamily: 'zenmaru, serif' }}>
                      <div className="flex justify-between items-center mb-2">
                        <h4 className="text-medium font-semibold text-gray-800">{option.label}</h4>
                        <span className="text-gray-700 font-sm">{option.price}</span>
                      </div>
                      {option.description && (
                        <p className="text-xs text-gray-600 leading-relaxed whitespace-pre-line">{option.description}</p>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Conditional Rendering for Printing Plan */}
          {bookTab === 'printing' && (
            <div>
              {/* <div className='flex justify-center my-5 text-xs text-gray-600 mt-6 leading-loose' style={{ fontFamily: 'zenmaru, serif' }}>
                <p className='text-center '>
                  中綴じ冊子 A5サイズ (210×148mm)<br />
                  印刷も併せてご希望の場合はこちらのプランをお選びください<br />

                </p>
              </div> */}
              <div className="border border-gray-800 p-4 mb-8" style={{ fontFamily: 'zenmaru, serif' }}>
                <h3 className="text-xl font-bold text-center mb-4 bg-amber-100 p-2 border-b border-gray-800 tracking-wide" style={{ fontFamily: 'Hatton, serif' }}>
                  semi order
                </h3>
                {/* Table-like Layout */}
                <div className="overflow-x-auto">
                  {/* <table className="table-auto w-full border-collapse border border-gray-800"> */}
                  <table className="table-auto border-collapse border border-gray-800 w-full">
                    <thead className="bg-gray-100">
                      <tr>
                        <th className="border border-gray-800 px-4 py-2">ページ数</th>
                        <th className="border border-gray-800 px-4 py-2">二つ折り席次表（4P）</th>
                        <th className="border border-gray-800 px-4 py-2">巻三つ折り席次表（6P）</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="border border-gray-800 px-4 py-2 text-center">〜100部</td>
                        <td className="border border-gray-800 px-4 py-2 text-center">¥20,000</td>
                        <td className="border border-gray-800 px-4 py-2 text-center">¥23,000</td>
                      </tr>
                      <tr>
                        <td className="border border-gray-800 px-4 py-2 text-center">〜200部</td>
                        <td className="border border-gray-800 px-4 py-2 text-center">¥21,000</td>
                        <td className="border border-gray-800 px-4 py-2 text-center">¥24,000</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className='flex justify-center'>
                  <p className="text-xs text-center text-gray-600 mt-6 leading-relaxed" style={{ fontFamily: 'zenmaru, serif' }}>
                    公式HP・Instagram投稿内のデザインからお好きなページをご自由に組み合わせていただけます<br />
                    中綴じ冊子 A5サイズ (210×148mm)<br />
                  </p>
                </div>
              </div>
      
              <div className="border border-gray-800 p-4 mb-8">
                <h3 className="text-xl font-bold text-center mb-4 bg-amber-100 p-2 border-b border-gray-800 tracking-wide" style={{ fontFamily: 'Hatton, serif' }}>
                  option
                </h3>
                <div className="mt-6 space-y-8">
                  {[
                    {
                      label: 'お急ぎ納品',
                      price: '+¥10,000',
                      description:
                        'ご注文が挙式日より60日を切ってしまっている場合、こちらをお選びください（納品希望日30日前まで）\n※納品希望日は挙式日の20日前までとなります',
                    },
                    {
                      label: 'オリジナルページ作成',
                      price: '1ページにつき+¥3,000',
                      description:
                        'セミオーダー料金 + ご希望のオリジナルページ数×¥3,000\nお客様のご要望に合わせてデザインを1からお作りいたします',
                    },
                    {
                      label: '試し刷り',
                      price: '+¥4,000',
                      description:
                        '仕上がりが気になる方は本番刷りの前に少ない部数で試し刷りが可能です',
                    },
                    {
                      label: '上質紙に変更',
                      price: '+¥1,000',
                      description:
                        '通常のマットコート紙に比べて光沢はほぼないものになります',
                    },
                  ].map((option, index) => (
                    <div key={index} className="border border-gray-300 p-4 shadow-sm" style={{ fontFamily: 'zenmaru, serif' }}>
                      <div className="flex justify-between items-center mb-2">
                        <h4 className="text-medium font-semibold text-gray-800">{option.label}</h4>
                        <span className="text-gray-700 font-sm">{option.price}</span>
                      </div>
                      {option.description && (
                        <p className="text-xs text-gray-600 leading-relaxed whitespace-pre-line">{option.description}</p>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Conditional Rendering for Wedding Photo */}
      {selectedPlan === 'photo' && (
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 font-serif uppercase tracking-wide" style={{ fontFamily: 'Hatton, serif' }}>
            Wedding Photo Plans
          </h2>
          <p className="text-xl text-gray-600">Coming Soon...</p>
        </div>
      )}

      <div className="text-center mt-10">
        <button
          onClick={() => setIsModalOpen(true)}
          className="bg-pink-500 hover:bg-pink-600 text-white font-semibold py-3 px-6 rounded shadow"
        >
          見積もりシミュレーターを開く
        </button>

        {isModalOpen && (
          <EstimateModal onClose={() => setIsModalOpen(false)} />
        )}
      </div>
    </div>
  );
};

export default Plan;
